export default __webpack_public_path__ + "static/media/events-icon.0161dadb.svg";